(() => {
  const linksFor = nav => [...nav.querySelectorAll('a[href]:not(.page-tabs__back, .page-tabs__action)')]; /* changed */
  const update = (nav, selected) => {
    for (const link of linksFor(nav)) {
      if (link === selected) link.setAttribute('aria-current', link.hash ? 'location' : 'page');
      else link.removeAttribute('aria-current');
      link.classList.toggle('is-current', link === selected);
    }
    const select = nav.querySelector('.page-tabs__select');
    if (select && selected) select.value = selected.href;
  };
  const initialize = root => {
    for (const nav of root.querySelectorAll('.page-tabs:not([data-page-tabs-ready])')) {
      const links = linksFor(nav);
      if (!links.length) continue;
      let selected = links.find(link => link.hasAttribute('aria-current') || link.classList.contains('is-current'));
      for (const link of links) {
        if (link.origin !== location.origin || link.pathname !== location.pathname) continue;
        if (!link.hash) selected ||= link;
        else {
          let target;
          try { target = document.getElementById(decodeURIComponent(link.hash.slice(1))); } catch { continue; }
          target?.classList.add('page-tabs-target');
          if (link.hash === location.hash) selected = link;
        }
      }
      if (!nav.classList.contains('about-tabs')) {
        const select = document.createElement('select');
        select.className = 'page-tabs__select';
        select.setAttribute('aria-label', nav.getAttribute('aria-label') || links[0].textContent.trim());
        for (const link of links) select.add(new Option(link.textContent.trim(), link.href));
        nav.append(select);
      }
      nav.dataset.pageTabsReady = '';
      update(nav, selected || links[0]);
    }
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('.page-tabs a[href]');
    if (link && !link.matches('.page-tabs__back, .page-tabs__action')) update(link.closest('.page-tabs'), link); /* changed */
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.page-tabs__select')) return;
    const nav = event.target.closest('.page-tabs');
    const link = linksFor(nav).find(link => link.href === event.target.value);
    if (link) { update(nav, link); location.assign(link.href); }
  });
  window.addEventListener('hashchange', () => {
    for (const nav of document.querySelectorAll('.page-tabs')) {
      const link = linksFor(nav).find(link => link.origin === location.origin && link.pathname === location.pathname && link.hash === location.hash);
      if (link) update(nav, link);
    }
  });
})();